import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Footerwithdr from "../../../common_components/Footerwithdr";
import { downloadReport, toastError, toastSuccess } from "../../../utils/constants";
import { proformaInvoice_action } from "../../../actions/admin_module_action/registration_receipt_actions/receipt_action";
import { getProformaPdf_action, proformaInvList_action, proformaInvShare_action } from "../../../actions/exhibitor_module_actions/ProformaInvoiceList_action/proformaInvList_action";
import { data } from "jquery";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Pagination from "../../../utils/pagination";
import ConfirmationModal from "../../../common_components/confirmationa_modal";


const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        value={value}
        className="form-control"
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    ></input>
));

class ProformaList extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            proformaInv: [],
            exhibitor: "",
            proformaDate: "",
            proformaNo: "",
            currentPage: 1,
            PIIDArr: [],
            flag: '',
            loginAccesslist: [],
        }
        this.proformaInvoice = this.proformaInvoice.bind(this)
        this.onShare = this.onShare.bind(this)
        this.onPdfDownload = this.onPdfDownload.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.getSendAccess = this.getSendAccess.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }

    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onPdfDownload(popArg[0], popArg[1], popArg[2], popArg[3])
            }
            if (confirmationObj.action == 1) {
                this.onShare(popArg[0], popArg[1], popArg[2])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.setState({
            flag: this.props.location.state != null && this.props.location.state.Flag != null ? this.props.location.state.Flag : '',
        }, () => {
            this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
            console.log(this.props.location.state)
            this.proformaInvoice()
        })

    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '3');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }

    // handle Proforma invoice
    proformaInvoice() {
        const { exhibitor, proformaDate, proformaNo, flag } = this.state
        var exhibitorCompanyName = JSON.parse(sessionStorage.getItem("loginDataSS"))["CompanyName"]
        this.setState({ isLoading: true, proformaInv: [] })
        this.props.proformaInvList_action(exhibitor, proformaDate, proformaNo, flag != '' && flag != null ? flag : null)
            .then((data) => {
                if (data.error != 1) {
                    var list = []
                    console.log("proInvoices1111111111", data.data)
                    //sort on basis of flag
                    data.data.length > 0 && data.data.map((item) => (
                        item.is_checked = 0
                    ))
                    this.setState({ isLoading: false, proformaInv: data.data }, () => { })


                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((e) => {
                console.log(e)
            })
    }

    // On Pdf Download Click
    onPdfDownload(ExhRegistrationID, countryId, installmentType, formID) {
        this.setState({ isLoading: true })
        this.props.getProformaPdf_action(ExhRegistrationID, countryId, installmentType, formID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On Search Proforma Click
    onSearchClick() {
        const { exhibitor, proformaDate, proformaNo } = this.state
        if (exhibitor != "" || proformaDate != "" || proformaNo != "") {
            this.proformaInvoice()
        } else {
            toastError("Atleast Fill One field to Search")
        }
    }

    handleKeyDown(e) {
        if (e.code == 'Enter') {
            this.searchReceipt()
        }
    }

    clearValue() {
        this.setState({
            exhibitor: "",
            proformaDate: "",
            proformaNo: "",
        })
        setTimeout(() => {
            this.proformaInvoice()
        }, 500);
    }

    // Update Current Page
    updateItem(item) {
        const { proformaInv } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = proformaInv.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(proformaInv.length / recordsPerPage)
    }


    onShare(PIID, type, FormID) {
        console.log(PIID, type, FormID)
        const { proformaInv } = this.state
        const PIIdArray = []
        console.log("ProformaInvoiceID ProformaInvoiceID ", PIID)
        proformaInv.map((data) => {
            if (data.is_checked === 1) {
                PIIdArray.push(
                    {
                        "ProformaInvoiceID": data.ProformaInvoiceID,
                        "ProformaInvoice_Type": data.ProformaInvoice_Type,
                        "FormID": data.FormID,
                    }
                )
            }
        })

        const singlePIIdArray = []
        singlePIIdArray.push(
            {
                "ProformaInvoiceID": PIID,
                "ProformaInvoice_Type": type,
                "FormID": FormID,
            }
        )

        // console.log("receiptIdArray", receiptIdArray)

        this.setState({ isLoading: true })
        this.props
            .proformaInvShare_action(PIID != undefined ? singlePIIdArray : PIIdArray)
            .then((data) => {
                if (data.error != 1) {
                    console.log("receipt share !!!!!!!!!!!!", data.data);
                    this.setState({ isLoading: false })
                    toastSuccess("PI share successfully!", {
                        theme: 'colored',
                        autoClose: 500,
                        hideProgressBar: true,
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false })
                console.log(e);
            });
    }


    render() {
        const { isLoading, proformaInv, isOpenConfirmationModal, exhibitor, proformaDate, proformaNo, currentPage } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = proformaInv.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(proformaInv.length / recordsPerPage)

        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <ExhibitorHeader /> : <HeaderWithLogo />
                }
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"} style={{ marginTop: '4rem' }}>
                    <div className="main-container admin-top-space-1">
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorDrawer /> : <AdminDrawer />
                        }
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorTopMenu /> : null
                        }


                    </div>
                    {
                        JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                        <div className="row m-0 mx-2 align-items-end">
                            <div className="col-xl-3 mb-3">
                                <label>Exhibitor</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={exhibitor}
                                    onKeyDown={e => this.handleKeyDown(e)}
                                    onChange={(e) => this.setState({ exhibitor: e.target.value })}
                                />
                            </div>

                            <div className="col-xl-3 mb-3">
                                <label>Proforma Date</label>
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={proformaDate}
                                    onKeyDown={e => this.handleKeyDown(e)}
                                    onChange={(date) => this.setState({ proformaDate: date })}
                                    placeholderText="Proforma Date"
                                    customInput={<ExampleCustomInput />}
                                />
                            </div>

                            <div className="col-xl-3 mb-3">
                                <label>Proforma Invoice No</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={proformaNo}
                                    onKeyDown={e => this.handleKeyDown(e)}
                                    onChange={(e) => this.setState({ proformaNo: e.target.value })}
                                />
                            </div>

                            {JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 && (
                                <div className="col-xl-2 mb-3 d-flex justify-content-center gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        onClick={e => this.onSearchClick()}
                                    >
                                        Search
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        onClick={e => this.clearValue()}
                                    >
                                        Clear
                                    </button>
                                </div>
                            )}
                        </div>

                    }
                    <div className="row mx-2">

                        <div className="table-responsive px-1 sticky-table-wrapper service-list-grid mx-2">
                            <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Proforma Invoice No.</th>
                                        <th>Exhibitor Name</th>
                                        <th>Proforma Date </th>
                                        <th>Service </th>
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>Taxable Amount </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>Tax Type </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>CGST </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>SGST </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>IGST </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>Total Payable </th>}
                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>Outstanding </th>}
                                        {/* <th> </th>
                                                <th>CGST </th>
                                                <th>SGST</th>
                                                <th>IGST	</th>
                                                <th>Total Payable</th>
                                                <th>Outstanding</th> */}
                                        <th className="" style={{ width: '20px' }} colSpan={(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6 || this.getSendAccess() || this.getDownloadAccess()) ? 2 : 1}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        proformaInv.length > 0 ?
                                            currentRecords.map((data, index) => (
                                                <>
                                                    <tr key={index}>

                                                        <td>{data.ProformaInvoice_No}</td>
                                                        <td>{data.ExhibitorName}</td>
                                                        <td>{new Date(data.ProformaInvoice_Date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                        <td>{data.Service}</td>
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.TaxableAmount}</th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.Tax_Type} </th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.CGST}</th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.SGST} </th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.IGST} </th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.Total_Payable} </th>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6) && <th>{data.Outstanding} </th>}
                                                        {/* <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td> */}
                                                        {this.getDownloadAccess() && <td>

                                                            <i className="fa fa-download grid-icon" aria-hidden="true"
                                                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download PI?', buttonName: 'Download', action: 0 }, popArg: [data.ExhRegistrationID, data.CountryID, data.ProformaInvoice_Type, data.FormID] })}
                                                            //   onClick={(e) => this.onPdfDownload(data.ExhRegistrationID, data.CountryID, data.ProformaInvoice_Type, data.FormID)}
                                                            />
                                                        </td>}
                                                        {(parseInt(sessionStorage.getItem("RoleIDSS")) == 2 || parseInt(sessionStorage.getItem("RoleIDSS")) == 5 || parseInt(sessionStorage.getItem("RoleIDSS")) == 6 || this.getSendAccess()) && <td>

                                                            <i className="fa fa-share grid-icon" aria-hidden="true"
                                                                // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Share PI?', buttonName: 'Share', action: 1 }, popArg: [data.ProformaInvoiceID, data.ProformaInvoice_Type, data.FormID] })}
                                                                onClick={(e) => this.onShare(data.ProformaInvoiceID, data.ProformaInvoice_Type, data.FormID)}
                                                            />
                                                        </td>}
                                                    </tr>
                                                </>
                                            )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                    }
                                    {/* {
                                                currentRecords.length > 0 &&
                                                <tr>
                                                    <td />
                                                    <td />
                                                    <td />
                                                    <td />
                                                    <td>
                                                        <strong>{taxableAmount}</strong>
                                                    </td>
                                                    <td>
                                                        <strong></strong>
                                                    </td>
                                                    <td>
                                                        <strong></strong>
                                                    </td>
                                                    <td>
                                                        <strong></strong>
                                                    </td>
                                                    <td>
                                                        <strong>{totalReceivedAmt}</strong>
                                                    </td>
                                                    <td />
                                                    <td />
                                                </tr>
                                            } */}

                                </tbody>
                            </table>
                        </div>
                        <div className="mt-2 float-left trp">
                            {
                                proformaInv.length > 0 ?
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.updateItem}
                                    /> : <></>
                            }
                            <div className="table-record-pages">
                                <p>{`${currentPage} of ${nPages} pages`}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Footerwithdr /> */}
            </>
        )
    }
}
export default withRouter(connect(null, { proformaInvList_action, getProformaPdf_action, proformaInvShare_action })(ProformaList))